import { Flex, Typography } from '@coolblue-development/freddy';
import { memo } from 'react';

import { ObjectRawDataObject } from './ObjectRawDataObject';

export const ObjectRawData = memo(function ObjectRawData({
  obj,
  depth = 0,
  startExpanded = false
}: {
  obj: object;
  depth?: number;
  startExpanded?: boolean;
}) {
  return (
    <>
      {Object.keys(obj).map((objectKey, index) => {
        const item = obj as Record<string, unknown>;
        const value = item[objectKey];

        if (typeof value === 'object' && value !== null && value !== undefined) {
          return (
            <ObjectRawDataObject
              key={objectKey}
              objectKey={objectKey}
              index={index}
              depth={depth}
              value={value}
              startExpanded={startExpanded}
            />
          );
        }

        return (
          <Flex
            key={objectKey}
            mb={100}
            sx={{
              marginLeft: `${depth}px`
            }}
          >
            <Flex key={objectKey + index} gap={200}>
              <Typography
                fontSize='14px'
                mb={0}
                color='headingMain'
                sx={{
                  textWrap: 'nowrap'
                }}
                fontWeight={600}
              >
                {objectKey} :
              </Typography>
              <Typography fontSize='14px' mb={0}>
                {value === null && <strong>null</strong>}
                {value === undefined && <strong>undefined</strong>}
                {typeof value === 'string' && value}
                {(typeof value === 'boolean' || typeof value === 'number') && (
                  <strong>{value.toString()}</strong>
                )}
              </Typography>
              <Typography fontSize='sm' mb={0} color='interactiveSubtle'>
                {typeof value}
              </Typography>
            </Flex>
          </Flex>
        );
      })}
    </>
  );
});
